export const TechnicalSpecs = () => {
  const specs = [
    {
      category: 'Synthesis Efficiency',
      metrics: [
        { label: 'CNF Yield Ratio', value: '1:40', unit: 'weight basis' },
        { label: 'Processing Time', value: '&lt;2', unit: 'hours' },
        { label: 'Energy Consumption', value: '60%', unit: 'reduction vs. conventional' }
      ]
    },
    {
      category: 'Performance Characteristics',
      metrics: [
        { label: 'Tensile Strength', value: '+35%', unit: 'improvement' },
        { label: 'Opacity Enhancement', value: '+25%', unit: 'vs. standard fillers' },
        { label: 'Surface Smoothness', value: '95%+', unit: 'uniformity index' }
      ]
    },
    {
      category: 'Economic Impact',
      metrics: [
        { label: 'Pulp Replacement', value: '40-50%', unit: 'substitution rate' },
        { label: 'Cost Savings', value: '$150-200', unit: 'per ton' },
        { label: 'ROI Timeline', value: '12-18', unit: 'months' }
      ]
    }
  ];

  return (
    <section id="technical-specs" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Technical Specifications
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Industry-leading performance metrics backed by rigorous testing
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {specs.map((spec, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-slate-800 to-slate-900 border border-slate-700 rounded-2xl p-8"
            >
              <h3 className="text-2xl font-bold text-amber-400 mb-8 pb-4 border-b border-slate-700">
                {spec.category}
              </h3>
              <div className="space-y-6">
                {spec.metrics.map((metric, idx) => (
                  <div key={idx}>
                    <p className="text-sm text-gray-400 mb-2">{metric.label}</p>
                    <div className="flex items-baseline">
                      <span className="text-3xl font-bold text-white mr-2" dangerouslySetInnerHTML={{ __html: metric.value }}></span>
                      <span className="text-sm text-gray-500">{metric.unit}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-slate-800 to-slate-900 border border-slate-700 rounded-2xl p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/d1156fa0eac9bef9006fcba6320f314e.jpg"
                alt="Microscopic Fiber Structure"
                className="rounded-xl shadow-2xl object-cover w-full h-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 to-transparent rounded-xl"></div>
            </div>

            <div>
              <h3 className="text-3xl font-bold text-white mb-6">
                Breakthrough Synthesis Process
              </h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-amber-500/20 border border-amber-500/30 rounded-lg flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <span className="text-amber-400 font-bold text-sm">1</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">Mineral Filler Integration</h4>
                    <p className="text-gray-400 text-sm">Advanced binding technology enables unprecedented filler-to-CNF ratios</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-amber-500/20 border border-amber-500/30 rounded-lg flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <span className="text-amber-400 font-bold text-sm">2</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">Optimized Dispersion</h4>
                    <p className="text-gray-400 text-sm">Uniform distribution ensures consistent paper quality and performance</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-amber-500/20 border border-amber-500/30 rounded-lg flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <span className="text-amber-400 font-bold text-sm">3</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-1">Enhanced Bonding</h4>
                    <p className="text-gray-400 text-sm">Superior fiber-to-filler adhesion maintains structural integrity</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
